module.exports = __webpack_public_path__ + "4f052fc9a27aa465112f2ec08695f0aa.svg";